import { apiCall } from './gqlClient';

const GETMYENTITLEMENTS_QUERY = `
  query getMyEntitlements {
    getMyEntitlements
    {
      providerId
			planId
			booleans
			limits
			meters
      ...fragments
    }
  }`;

export const getMyEntitlementsApiCall = async (fragments = null) => apiCall({ query: GETMYENTITLEMENTS_QUERY, variables: {}, fragments });

const GETPROVIDERENTITLEMENTS_QUERY = `
  query getProviderEntitlements($providerId: Int!) {
    getProviderEntitlements(providerId: $providerId)
    {
      providerId
			planId
			booleans
			limits
			meters
      ...fragments
    }
  }`;

export const getProviderEntitlementsApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPROVIDERENTITLEMENTS_QUERY, variables: {providerId}, fragments });
